module.exports = __webpack_public_path__ + "img/cliente-o-proveedor.881b6481.svg";